import store from '@/store/store'

const converter = (fieldBase = null) => {
  if (!Array.isArray(fieldBase)) return fieldBase
  const language = store.state.languages.list
  let result = []
  if (!language) {
    return result
  }
  if (fieldBase && fieldBase.length) {
    language.forEach((item) => {
      let search = fieldBase.find((element) => element.iso === item.iso)
      if (!search) {
        search = item
      }
      result.push({
        text: search.text || '',
        name: item.name,
        iso: item.iso,
      })
    })
    return result
  }
  language.forEach((item) => {
    result.push({
      text: '',
      name: item.name,
      iso: item.iso,
    })
  })
  return result
}

const mixinConverterLanguage = {
  methods: {
    converter(fieldBase = null) {
      return converter(fieldBase)
    },
  },
}

export default mixinConverterLanguage
